import React from 'react';

import ReactDOMClient from 'react-dom/client';
import singleSpaReact from 'single-spa-react';

import App from './components/App';

const reactLifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: App,
});

export const bootstrap = [reactLifecycles.bootstrap];

export const mount = [reactLifecycles.mount];

export const unmount = [reactLifecycles.unmount];
